import { render, staticRenderFns } from "./InformacionGeneralPlanificacionAnualCharterTabs.vue?vue&type=template&id=af57fc28&scoped=true"
import script from "./InformacionGeneralPlanificacionAnualCharterTabs.vue?vue&type=script&lang=js"
export * from "./InformacionGeneralPlanificacionAnualCharterTabs.vue?vue&type=script&lang=js"
import style0 from "./InformacionGeneralPlanificacionAnualCharterTabs.vue?vue&type=style&index=0&id=af57fc28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af57fc28",
  null
  
)

export default component.exports